import { render } from "./DetailsMedicalView.vue?vue&type=template&id=7e53553c"
import script from "./DetailsMedicalView.vue?vue&type=script&lang=js"
export * from "./DetailsMedicalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__